import React, { Component } from 'react';
import { TweenMax } from 'gsap';
import RegisterBlock from "../modules/RegisterBlock";
import InlineTextBlocks from "../modules/InlineTextBlocks/InlineTextBlocks";
import Table from "../modules/Table";
import OutageGuarantee from "../modules/OutageGuarantee";
import globals from '../globals';
import Hero from "../modules/Hero/Hero";
import HelmetDefault from "../layout/HelmetDefault";
import Button from "../elements/Button";
import PriceCheckerForm from "../forms/PriceCheckerForm/PriceCheckerForm";

class InternetFibre extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            inlineTextBlocks: {},
            internetPlans: {},
            serviceAgreement: {},
			form: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/internet/business-fibre')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    scrollToForm(event) {
    	event.preventDefault();
		let form = document.getElementById('price-checker-form');
		TweenMax.to(window, 0.5, {scrollTo: (form.offsetTop - 60)});
	}

    handleClickCta(event) {
        this.scrollToForm(event)
        globals.pushGA4Events('bannerCtaClick', {
            eventInfo: {
                clickText: "View Prices",
                clickUrl: window.location.href,
                pageCategory: 'Business'
            }
        })
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived}>
					<Button
						action={event => this.handleClickCta(event)}
						newClass="scroll-to-pricing"
						image="/images/btn-view-prices.svg"
						alt="View Prices"
					/>
				</Hero>
				<InlineTextBlocks data={this.state.inlineTextBlocks} dataReceived={this.state.dataReceived} />
                <PriceCheckerForm
                    title={this.state.form.title}
                    subTitle={this.state.form.subTitle}
                    speeds={[20, 50, 100, 200, 500, 1000]}
                    submitFormUrl="/api/submit-price-checker-form/fibre"
                    getPricingUrl="/api/get-fibre-pricing"
                    eventNameSpeed="businessFibreFormSpeed"
                    eventNameSubmit="businessFibreFormSubmit"
                />
                <Table data={this.state.serviceAgreement} image="/images/suitcase-dude.png" />
                <OutageGuarantee />
                <RegisterBlock />
            </div>
        );
    }

}

export default InternetFibre;


// WEBPACK FOOTER //
// ./resources/assets/js/internet/InternetFibre.js